import { Component, OnInit, ViewChild } from '@angular/core';
import { DatatableComponent, ColumnMode } from '@swimlane/ngx-datatable';
import { FornecedorService } from 'app/services/fornecedor.service';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-fornecedor-list',
  templateUrl: './fornecedor-list.component.html',
  styleUrls: ['./fornecedor-list.component.scss']
})
export class FornecedorListComponent implements OnInit {
  
  // Private variables
  private _unsubscribeAll: Subject<any> = new Subject();
  
  // Public variables
  public loading: boolean = false;
  public ColumnMode = ColumnMode;
  public rows: any[] = []; // Adicione o tipo correto conforme necessário
  public basicSelectedOption: number = 10;
  public contentHeader: any; // Adicionando o cabeçalho
  private tempData = [];
  public temp = [];
  public selectedStatus: any;

  @ViewChild(DatatableComponent) table: DatatableComponent;

  constructor(
    private fornecedorService: FornecedorService,
    private router: Router
  ) { }

  async ngOnInit() {
    this.loading = true;
    
    try {
      const result = await this.fornecedorService.get();
      this.rows = Array.isArray(result) ? result : [];
      this.temp = Array.isArray(result) ? [...result] : [];
    } catch (error) {
      console.error('Erro ao carregar fornecedores:', error);
      // Initialize empty arrays on error
      this.rows = [];
      this.temp = [];
    } finally {
      this.loading = false;
    }

    // Configuração do cabeçalho
    this.contentHeader = {
      headerTitle: "Fornecedores",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          { name: "Início", isLink: false },
          { name: "Fornecedores", isLink: false }
        ]
      }
    };
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  // Add filter methods
  nomeFilter(event) {
    const val = event.target.value.toLowerCase();

    // filter our data
    const temp = this.temp.filter(function (d) {
      if (d.nome != null) {
        return d.nome.toLowerCase().indexOf(val) !== -1 || !val;
      }
    });

    // update the rows
    this.rows = temp;
    // Whenever the filter changes, always go back to the first page
    this.table.offset = 0;
  }

  contatoFilter(event) {
    const val = event.target.value.toLowerCase();

    // filter our data
    const temp = this.temp.filter(function (d) {
      if (d.contato != null) {
        return d.contato.toLowerCase().indexOf(val) !== -1 || !val;
      }
    });

    // update the rows
    this.rows = temp;
    this.table.offset = 0;
  }

  statusFilter() {
    if (this.selectedStatus == 0) {
      this.rows = this.temp;
      return false;
    }
    const val = this.selectedStatus;

    // filter our data
    const temp = this.temp.filter(function (d) {
      return d.flg_status.toString() === val.toString();
    });

    // update the rows
    this.rows = temp;
    // Whenever the filter changes, always go back to the first page
    this.table.offset = 0;
  }

  onEdit(id_fornecedor) {
    this.router.navigate(['fornecedor/editar/', id_fornecedor]);
  }

  async onDelete(id_fornecedor: number) {
    // Show confirmation dialog
    const result = await Swal.fire({
      title: 'Tem certeza?',
      text: "Esta ação não poderá ser revertida!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Remover',
      cancelButtonText: 'Cancelar'
    });

    if (result.isConfirmed) {
      try {
        this.loading = true;
        await this.fornecedorService.delete(id_fornecedor);
        
        // Remove the deleted item from the arrays
        this.rows = this.rows.filter(row => row.id_fornecedor !== id_fornecedor);
        this.temp = this.temp.filter(row => row.id_fornecedor !== id_fornecedor);
        
        Swal.fire(
          'Deletado!',
          'O fornecedor foi deletado com sucesso.',
          'success'
        );
      } catch (error) {
        console.error('Erro ao deletar fornecedor:', error);
        Swal.fire(
          'Erro!',
          'Ocorreu um erro ao deletar o fornecedor.',
          'error'
        );
      } finally {
        this.loading = false;
      }
    }
  }

  public onCreate(): void {
    this.router.navigate(['fornecedor/cadastro']);
  }
}
